
import { defineComponent } from "vue";
import { mapActions, mapGetters } from "vuex";
import LoadingSpinnerSmall from "../LoadingSpinnerSmall.vue";

export default defineComponent({
  name: 'SignUpReportLoadingModal',
  components: {
    LoadingSpinnerSmall,
  },
  emits: ["close"],
  methods: {
    ...mapActions(['toggleSignUpReportLoadingModal']),
  },
  computed: {
    ...mapGetters(['showSignUpReportLoadingModal', 'loadingModalType']),
    title(): string {
      if (this.loadingModalType === "processingPayment") {
        return this.$t("reports.processing_payment");
      }
      return this.$t("reports.sign_up_loading_header");
    },
    text(): string | null {
      if (this.loadingModalType === "processingPayment") {
        return null
      }
      return this.$t('reports.sign_up_loading_text')
    }
  },
});
